@if (auth()) {
  <a
    #p="ngbPopover"
    placement="bottom"
    (click)="getNotifications()"
    [ngbPopover]="notificationsTemplate"
    popoverClass="popover-noti"
    class="notifications-btn notifications-empt"
  >
    <img class="white-icon" src="img/icons/notifications_bell2.png" alt="Notificaciones" height="24px" />
  </a>
}

<ng-template #notificationsTemplate>
  @let localNotifications = notifications();
  <div id="user" style="padding: 0 !important" class="popOver animated">
    <div class="notifications-content">
      @if (localNotifications) {
        <ul>
          @for (n of localNotifications; track n.id) {
            <li class="d-flex align-items-center">
              <img
                class="notification-icon"
                [src]="
                  n.type === 'sms' ? 'img/notificaciones-sms.png' : 'img/notificaciones-email.png'
                "
              />
              <div class="notification-text">
                {{
                  (n.type === 'sms'
                    ? 'hemos_enviado_un_mensaje_a_tu_celular'
                    : 'hemos_enviado_un_mensaje_a_tu_correo_1'
                  ) | translate
                }}
                <strong>{{ n.subscription }}.</strong>
                <br />
                <label class="my-2">{{ n.creation_date | date }}</label>
              </div>
            </li>
          }
        </ul>
      }

      @if (!localNotifications) {
        <div class="item noti">
          <ngx-skeleton-loader count="5" [theme]="{ 'border-radius': '0', height: '20px' }" />
        </div>
      }
    </div>

    @if (localNotifications && localNotifications.length === 0) {
      <div class="notifications-content empty px-3 text-center">
        <img class="mt-3" src="img/icons/notification_icon-empty.png" alt="no-notificaciones" />
        <h3 class="mb-0 mt-4">{{ 'not_notifications_title' | translate }}</h3>
        <span>{{ 'not_notifications_message' | translate }}</span>
      </div>
    }
    <div class="notifications-btn-bottom text-center mb-3">
      <hr />
      <a [routerLink]="['profile']" title="">
        {{ '$ver_suscripciones_activas' | translate }}
      </a>
    </div>
  </div>
</ng-template>
